import { getDomainConfigValue } from "../../utils/domain-config";
import { config } from "../../vue/helpers/domain-config";
import {
    PRODUCT_HK_XR_A,
    PRODUCT_XR_ACADEMY,
} from "../../vue/helpers/page-constants";
import { getGenericData } from "../../vue/utils/aframe.utils";
import { getDesktopCamera } from "../utils/camera.utils";
import { setHasSeenIntro } from "../utils/session-storage.utils";

AFRAME.registerComponent("intro", {
  init: function () {
    this.transitionVideoLoaded = this.transitionVideoLoaded.bind(this);

    this.elBackground = this.el.querySelector(".background");
    this.elCanvas = this.el.sceneEl.canvas;
    this.elSceneMainMenu = document.getElementById("scene-main_menu");
    this.elIntro = document.getElementById("intro");
    this.elTransition = document.getElementById("transition-video");
    this.elTransitionVideo = this.elTransition.querySelector("video");
    this.elVue = document.querySelector("#vue");
    document.body.style.overflowY = "hidden";
    this.elCanvas.classList.add("hidden");
    this.elTransition.style.opacity = 0.4;
    this.elVue.classList.add("hidden-for-intro");

    getGenericData().then(({ welcomeText }) => {
      document.querySelector(".welcome-to p").innerHTML = welcomeText;
    });
    this.elIntro.style.opacity = 1;

    const src = `https://blobs-xr-academy-fxhygyhwcddyerbg.z03.azurefd.net/videos/transition-${
      window.innerWidth < 640 ? "mobile" : "desktop"
    }.mp4`;
    this.elTransitionVideo.setAttribute("style", "opacity: 0");
    this.elTransitionVideo.setAttribute("src", src);
    this.elTransitionVideo.play();

    this.elTransitionVideo.addEventListener(
      "canplaythrough",
      this.transitionVideoLoaded
    );
    if (
      (config.productName === PRODUCT_XR_ACADEMY &&
        config.subdomain === "my") ||
      config.productName === PRODUCT_HK_XR_A
    ) {
      this.addBookmark();
    }
  },

  transitionVideoLoaded: function () {
    this.elTransitionVideo.removeEventListener(
      "canplaythrough",
      this.transitionVideoLoaded
    );

    // if (this.elTransitionVideo.currentTime > 0) {
    this.elTransitionVideo.setAttribute("style", "opacity: 1");
    // }

    let backgroundColorHack = false;
    this.backgroundColorInterval = setInterval(() => {
      try {
        this.elTransitionVideo.style.backgroundColor = backgroundColorHack
          ? "#000000"
          : "#000001";
        backgroundColorHack = !backgroundColorHack;
      } catch (e) {}
    }, 100);

    setTimeout(() => this.waitForTransition(), 5000);
  },

  waitForTransition: function () {
    this.loaded = false;
    this.transitionToMenu = this.transitionToMenu.bind(this);

    if (this.elBackground.components["load-asset"].assetLoaded) {
      this.transitionToMenu();
    } else {
      this.elBackground.addEventListener("assetLoaded", this.transitionToMenu);
    }
  },

  transitionToMenu: function () {
    if (this.loaded) {
      return;
    }

    this.loaded = true;

    setTimeout(() => {
      this.elCanvas.classList.remove("hidden");
      this.elIntro.style.opacity = 0;
      this.elTransition.style.opacity = null;
      this.elVue.classList.remove("hidden-for-intro");
      document.body.style.overflowY = "inherit";

      const dur = 4000;
      const easing = "easeInOutQuad";
      const zoom = 5;
      const elCamera = getDesktopCamera();
      elCamera.setAttribute("camera-zoom", "enabled", true);
      elCamera.setAttribute("animation__zoom-width", {
        property: "camera-zoom.width",
        dur,
        easing,
        from: 12 * zoom,
        to: 12,
      });

      elCamera.setAttribute("animation__zoom-height", {
        property: "camera-zoom.height",
        dur,
        easing,
        from: 12 * zoom,
        to: getDomainConfigValue("showFootballContent") || getDomainConfigValue("showWorldCupContent") ? 10 : 7,
      });

      elCamera.setAttribute("animation__position", {
        property: "position.y",
        dur: dur - 250,
        easing: "easeInQuad",
        from: 3,
        to: 0,
      });

      elCamera.setAttribute("animation__rotation", {
        property: "rotation.x",
        dur: dur - 250,
        easing: "easeInQuad",
        from: -75,
        to: 0,
      });

      setTimeout(
        () => {
          this.elSceneMainMenu.components[
            "main-menu-scene-controller"
          ].animateButtons(true);
          this.el.sceneEl.systems["vue-ux"].showVueElements(true);
        },
        window.screen.width > 640 ? dur / 2 : 0
      );

      setTimeout(() => {
        this.el.sceneEl.emit("activateLookCamera", {
          width: 12,
          height: getDomainConfigValue("showFootballContent") || getDomainConfigValue("showWorldCupContent") ? 10 : 7,
          staticIfMobile: true,
        });
        this.elTransition.parentElement.removeChild(this.elTransition);
        setHasSeenIntro();
      }, dur + 10);
      clearInterval(this.backgroundColorInterval);
    }, 1000);
  },
  addBookmark: function () {
    if (
      navigator.userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
      )
    ) {
      alert(
        'To bookmark this page on your mobile device, please use the browser menu and select "Add to Home Screen".'
      );
    } else {
      alert(
        "Press " +
          (navigator.userAgent.toLowerCase().indexOf("mac") !== -1
            ? "Command/Cmd"
            : "CTRL") +
          " + D to bookmark this page."
      );
    }
  },
});
